var k = Object.defineProperty;
var y = Object.getOwnPropertySymbols;
var P = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var g = (e, t, o) => t in e ? k(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, A = (e, t) => {
  for (var o in t || (t = {}))
    P.call(t, o) && g(e, o, t[o]);
  if (y)
    for (var o of y(t))
      I.call(t, o) && g(e, o, t[o]);
  return e;
};
import { f as L, aw as W, ax as _, q as j } from "./define-element-XpjsV6s1.js";
function C(e) {
  return W() ? (_(e), !0) : !1;
}
function S(e) {
  return typeof e == "function" ? e() : L(e);
}
const b = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const x = Object.prototype.toString, M = (e) => x.call(e) === "[object Object]", w = () => {
}, T = /* @__PURE__ */ q();
function q() {
  var e, t;
  return b && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function f(e) {
  var t;
  const o = S(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
const O = b ? window : void 0;
function h(...e) {
  let t, o, i, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([o, i, a] = e, t = O) : [t, o, i, a] = e, !t)
    return w;
  Array.isArray(o) || (o = [o]), Array.isArray(i) || (i = [i]);
  const d = [], p = () => {
    d.forEach((c) => c()), d.length = 0;
  }, l = (c, u, n, r) => (c.addEventListener(u, n, r), () => c.removeEventListener(u, n, r)), m = j(
    () => [f(t), S(a)],
    ([c, u]) => {
      if (p(), !c)
        return;
      const n = M(u) ? A({}, u) : u;
      d.push(
        ...o.flatMap((r) => i.map((s) => l(c, r, s, n)))
      );
    },
    { immediate: !0, flush: "post" }
  ), v = () => {
    m(), p();
  };
  return C(v), v;
}
let E = !1;
function B(e, t, o = {}) {
  const { window: i = O, ignore: a = [], capture: d = !0, detectIframe: p = !1 } = o;
  if (!i)
    return w;
  T && !E && (E = !0, Array.from(i.document.body.children).forEach((n) => n.addEventListener("click", w)), i.document.documentElement.addEventListener("click", w));
  let l = !0;
  const m = (n) => a.some((r) => {
    if (typeof r == "string")
      return Array.from(i.document.querySelectorAll(r)).some((s) => s === n.target || n.composedPath().includes(s));
    {
      const s = f(r);
      return s && (n.target === s || n.composedPath().includes(s));
    }
  }), c = [
    h(i, "click", (n) => {
      const r = f(e);
      if (!(!r || r === n.target || n.composedPath().includes(r))) {
        if (n.detail === 0 && (l = !m(n)), !l) {
          l = !0;
          return;
        }
        t(n);
      }
    }, { passive: !0, capture: d }),
    h(i, "pointerdown", (n) => {
      const r = f(e);
      l = !m(n) && !!(r && !n.composedPath().includes(r));
    }, { passive: !0 }),
    p && h(i, "blur", (n) => {
      setTimeout(() => {
        var r;
        const s = f(e);
        ((r = i.document.activeElement) == null ? void 0 : r.tagName) === "IFRAME" && !(s != null && s.contains(i.document.activeElement)) && t(n);
      }, 0);
    })
  ].filter(Boolean);
  return () => c.forEach((n) => n());
}
export {
  B as o
};
